import { useEffect, useRef } from 'react';
import RangeSlider from 'react-range-slider-input';

export default function RangeInput({ id, value, onChange, displayUnit, min, max, step, ...rest }) {
  const wrapperRef = useRef(null);

  // This useEffect is to circumvent a bug that happens when the parent element's is not calculated properly
  // This happens for @dnd-kit when dragging and dropping components, like in Page Builder template fields.
  useEffect(() => {
    const node = wrapperRef.current;
    if (!node) return;

    // The ResizeObserver will fire when the element's size changes.
    const observer = new ResizeObserver((entries) => {
      // Only run when the element gets a width of at least 1px
      if (entries[0].contentRect.width > 0) {
        // Tells slider to recalculate it's dimensions
        window.dispatchEvent(new Event('resize'));
        // Done, stop observing to prevent further processing
        observer.disconnect();
      }
    });

    // Start observing the wrapper element for size changess
    observer.observe(node);

    // Cleanup the observer when the component unmounts.
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={wrapperRef} className="d-flex align-items-center gap-2 w-100">
      <RangeSlider
        className="single-thumb"
        thumbsDisabled={[true, false]}
        rangeSlideDisabled
        min={min}
        max={max}
        step={step}
        value={[min, value]}
        onInput={(val) => onChange(val[1])}
        {...rest}
      />
      <input
        className="form-control"
        type="number"
        id={`range-input-${crypto.randomUUID()}`}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        style={{ width: 80 }}
      />
      <span className="text-muted">{displayUnit}</span>
    </div>
  );
}
